import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const login = createAsyncThunk(
  "login/login",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/isLoggedIn`, email);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
  {
    serializeError: true,
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(login.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default loginSlice.reducer;
